import { Button, DialogActions, DialogTitle } from "@material-ui/core";
import React from "react";

import getLogger, { LogGroup } from "js/core/logger";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";

export interface TransferOwnershipDialogProps {
    closeDialog: (accept: boolean) => void;
    newOwnerEmail: string;
}

const TransferOwnershipDialog = React.forwardRef<any, TransferOwnershipDialogProps>(function TransferOwnershipDialog({ closeDialog, newOwnerEmail }, ref) {
    return (
        <BeautifulDialog closeDialog={closeDialog} ref={ref}>
            <DialogTitle>Transfer Ownership</DialogTitle>
            <DialogContent>
                Do you want to give ownership of this presentation to {newOwnerEmail}? You will be made collaborator with editor
                permissions.
            </DialogContent>
            <DialogActions>
                <Button onClick={() => closeDialog(false)} color="secondary">
                    Cancel
                </Button>
                <Button onClick={() => closeDialog(true)} color="primary">
                    Make Owner
                </Button>
            </DialogActions>
        </BeautifulDialog>
    );
});

export default React.memo(TransferOwnershipDialog);
